import React from 'react';

export const Matchingtable = () => {
    return (
        <div data-testid="matching-table-div">
            <h3>You did well to match the pairs of cards!</h3>
            <h5>Now can you drag the prompts to the correct picture?</h5>
        </div>
    )
}

export default Matchingtable;